import { Controller } from "@hotwired/stimulus"

// Handles POST requests that open in a new tab
// Usage: data-controller="post-new-tab" data-post-new-tab-url-value="/path" data-action="click->post-new-tab#submit"
export default class extends Controller {
  static values = {
    url: String,
    confirm: { type: String, default: '' }
  }

  submit(event) {
    event.preventDefault()

    // Show confirmation if specified
    if (this.confirmValue && !confirm(this.confirmValue)) {
      return
    }

    // Create a form dynamically
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = this.urlValue
    form.target = '_blank'

    // Add CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content
    const csrfInput = document.createElement('input')
    csrfInput.type = 'hidden'
    csrfInput.name = 'authenticity_token'
    csrfInput.value = csrfToken
    form.appendChild(csrfInput)

    // Submit and clean up
    document.body.appendChild(form)
    form.submit()
    document.body.removeChild(form)
  }
}
